import {
  GET_CURRENT_PRODUCT_TABLE_BEGIN, GET_CURRENT_PRODUCT_TABLE_SUCCESS, GET_CURRENT_PRODUCT_TABLE_FAILURE,
  GET_PRODUCT_TABLES_BEGIN, GET_PRODUCT_TABLES_SUCCESS, GET_PRODUCT_TABLES_FAILURE,
  CLEAR_CURRENT_PRODUCT_TABLE_INFO,
  INSERT_PRODUCT_TABLE_DATA,
  POST_CREATE_PRODUCT_TABLE_BEGIN,
  POST_CREATE_PRODUCT_TABLE_SUCCESS,
  POST_CREATE_PRODUCT_TABLE_FAILURE,
  POST_ADD_PRODUCT_BEGIN,
  POST_ADD_PRODUCT_SUCCESS,
  POST_ADD_PRODUCT_FAILURE,
  CLEAR_ADDED_PRODUCTS,
  PUT_UPDATE_PRODUCT_TABLE_BEGIN,
  PUT_UPDATE_PRODUCT_TABLE_SUCCESS,
  PUT_UPDATE_PRODUCT_TABLE_FAILURE,
  RESET_PRODUCT_TABLE_STATE,
} from './../constants/ActionTypes'

const initialState = {
  currentTable: null,
  currentTableError: null,
  loadingCurrentTable: false,

  productTables: [],
  productTableError: null,
  loadingProductTables: false,

  cachedProductTable: null,

  createdProductTableInfo: null,
  createdProductTableError: null,
  creatingProductTable: false,

  updatedProductTableInfo: null,
  updatedProductTableError: null,
  updatingProductTable: false,

  addedProducts: [],
  addProductsError: null,
  addingProducts: false
}

const clearFetchedData = () => ({
  currentTable: null,
  currentTableError: null,
  loadingCurrentTable: false,

  productTables: [],
  productTableError: null,
  loadingProductTables: false  
})

const ReducerProductTable = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_CURRENT_PRODUCT_TABLE_BEGIN: {
      return {
        ...state,
        loadingCurrentTable: true,
        currentTableError: null,
        currentTable: null
      }
    }
    case GET_CURRENT_PRODUCT_TABLE_SUCCESS: {
      return {
        ...state,
        loadingCurrentTable: false,
        currentTableError: null,
        currentTable: payload.response
      }
    }
    case GET_CURRENT_PRODUCT_TABLE_FAILURE: {
      return {
        ...state,
        loadingCurrentTable: false,
        currentTableError: payload,
        currentTable: null
      }
    }

    case GET_PRODUCT_TABLES_BEGIN: {
      return {
        ...state,
        productTables: [],
        productTablesError: null,
        loadingProductTables: true,
      }
    }
    case GET_PRODUCT_TABLES_SUCCESS: {
      return {
        ...state,
        productTables: payload.response,
        productTablesError: null,
        loadingProductTables: false,
      }
    }
    case GET_PRODUCT_TABLES_FAILURE: {
      return {
        ...state,
        productTables: [],
        productTablesError: payload,
        loadingProductTables: false,
      }
    }

    case CLEAR_CURRENT_PRODUCT_TABLE_INFO: {
      return {
        ...state,
        currentTable: null,
        currentTableError: null,
        loadingCurrentTable: false
      }
    }

    case INSERT_PRODUCT_TABLE_DATA: {
      return {
        ...state,
        cachedProductTable: payload
      }
    }

    case POST_CREATE_PRODUCT_TABLE_BEGIN: {
      return {
        ...state,
        creatingProductTable: true,
        createdProductTableError: null,
        createdProductTableInfo: null
      }
    }
    case POST_CREATE_PRODUCT_TABLE_SUCCESS: {

      return {
        ...state,
        ...clearFetchedData(),
        creatingProductTable: false,
        createdProductTableError: null,
        createdProductTableInfo: payload.response
      }
    }
    case POST_CREATE_PRODUCT_TABLE_FAILURE: {
      return {
        ...state,
        creatingProductTable: false,
        createdProductTableError: payload.data,
        createdProductTableInfo: null
      }
    }

    case PUT_UPDATE_PRODUCT_TABLE_BEGIN: {
      return {
        ...state,
        updatingProductTable: true,
        updatedProductTableError: null,
        updatedProductTableInfo: null
      }
    }
    case PUT_UPDATE_PRODUCT_TABLE_SUCCESS: {

      return {
        ...state,
        ...clearFetchedData(),
        updatingProductTable: false,
        updatedProductTableError: null,
        updatedProductTableInfo: payload.response
      }
    }
    case PUT_UPDATE_PRODUCT_TABLE_FAILURE: {
      return {
        ...state,
        updatingProductTable: false,
        updatedProductTableError: payload.data,
        updatedProductTableInfo: null
      }
    }

    case POST_ADD_PRODUCT_BEGIN: {
      return {
        ...state,
        addingProducts: true,
        addProductsError: null,
      }
    }
    case POST_ADD_PRODUCT_SUCCESS: {

      return {
        ...state,
        addingProducts: false,
        addProductsError: null,
        addedProducts: [...state.addedProducts, payload.response]
      }
    }
    case POST_ADD_PRODUCT_FAILURE: {
      return {
        ...state,
        addingProducts: false,
        addProductsError: payload.data
      }
    }

    case CLEAR_ADDED_PRODUCTS: {
      return {
        ...state,
        addedProducts: [],
        addProductsError: null,
        addingProducts: false
      }
    }

    case RESET_PRODUCT_TABLE_STATE: {
      return initialState
    }

    default: return state
  }
}

export default ReducerProductTable